import React, { Fragment, useEffect, useContext, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { observer, useObserver } from "mobx-react-lite";
/* mui */
import Grid from "@material-ui/core/Grid";
/* mui */

/* packages */
import { GlobalContext } from "../../lib-atomic-context";
import { Inputs, Buttons, Invalid } from "../../lib-atomic";
import {
  FormHook,
  LocalStorage,
  FetchContextApi,
} from "../../lib-atomic-functions";
import {
  ModuleTitle,
  ModuleSubTitle,
  ModuleFormWrapper,
  ModuleFormItemWrapper,
  ModuleFormItemShortWrapper,
  ModuleFormItemLongWrapper,
  ModulePaperWrapper,
} from "../../lib-atomic-design-section";
/* packages */

import CONFIG from "../config";

/* CONSTANTS */
const CARRIERS = CONFIG.setup.assets.carriers;
const PRODUCTOBJECT = CONFIG.application.buynow.objects_notes;
const BUYNOWENDPOINTS = CONFIG.application.buynow.api.endpoints;
const PRODUCTCONFIG = {
  url: BUYNOWENDPOINTS.create.url,
  method: BUYNOWENDPOINTS.create.method,
  headers: BUYNOWENDPOINTS.create.headers,
  responseType: "json",
};
/* CONSTANTS */

const index = (props) => {
  const { handleNext, handleBack, handleReset } = props.handleSteps;
  const isNoteLS = LocalStorage.getLS().notes ? true : false;

  /* state */
  const [isNote, setIsNote] = useState(false);
  const [isTriggerCreate, setIsTriggerCreate] = useState(false);
  /* -------------- */
  /* --- notes */
  /* -------------- */
  const { notes } = useContext(GlobalContext);
  const execNotesAdd = (customnotes) => {
    notes.dispatch({
      type: notes.actionTypes.ADD_NOTES,
      notes: customnotes,
    });
  };
  useEffect(() => {
    // fetch local storage and put it inside context
    const notesLS = LocalStorage.getLS().notes;
    if (notesLS) {
      execNotesAdd({ ordernotes: notesLS });
    }
  }, []);
  useEffect(() => {
    if (notes.state.data && isTriggerCreate) {
      LocalStorage.addLS("notes", notes.state.data.ordernotes);
      setIsTriggerCreate(false);
    }
  }, [notes]);
  useEffect(() => {
    setIsNote(isNoteLS);
  }, [isNoteLS]);
  /* -------------- */
  /* --- notes */
  /* state */

  const handleCreate = async () => {
    const item = { ...values };
    console.log(item);
    // await createMethod({body: JSON.stringify(values)});
    execNotesAdd(item);
    LocalStorage.addLS("notes", item.ordernotes);
    onReset(PRODUCTOBJECT);
    setIsTriggerCreate(true);
  };

  // const handleCancel = async () => {
  //   props.history.push("/corporate");
  // };

  const { values, onReset, onChange, onSubmit, error } = FormHook.useFormHook(
    handleCreate,
    PRODUCTOBJECT,
  );

  // /* data props */
  // const product = {
  //   ...PRODUCTOBJECT.product,
  //   error: error.product,
  //   value: values.product,
  //   onChange
  // };
  // const value = {
  //   ...PRODUCTOBJECT.value,
  //   error: error.value,
  //   value: values.value,
  //   onChange
  // };
  const ordernotes = {
    ...PRODUCTOBJECT.ordernotes,
    error: error.ordernotes,
    value: values.ordernotes,
    onChange,
  };
  const actionButton = { size: "large" };
  const nextButton = { size: "large", onClick: handleNext };
  const backButton = { size: "large", onClick: handleBack };
  /* data props */

  return (
    <form onSubmit={onSubmit} noValidate>
      <ModulePaperWrapper>
        <ModuleFormWrapper>
          <ModuleFormItemLongWrapper>
            <ModuleSubTitle>
              You can specify purchase order number with regards to your order.
            </ModuleSubTitle>
          </ModuleFormItemLongWrapper>
        </ModuleFormWrapper>

        <ModuleFormWrapper>
          {/* line */}
          <ModuleFormItemWrapper>
            <Inputs.Text {...ordernotes} />
          </ModuleFormItemWrapper>
          {/* line */}
        </ModuleFormWrapper>

        <ModuleFormWrapper>
          {/* line */}
          <ModuleFormItemWrapper>
            <Buttons.Normal {...actionButton}>Add PO Number</Buttons.Normal>
          </ModuleFormItemWrapper>
          {/* line */}
        </ModuleFormWrapper>
      </ModulePaperWrapper>
      <div style={{ padding: 15, paddingTop: 20 }}>
        <ModuleFormWrapper>
          {/* line */}
          <ModuleFormItemLongWrapper>
            <Buttons.Text {...backButton}>Back</Buttons.Text>
            <Buttons.Normal {...nextButton}>Next</Buttons.Normal>
          </ModuleFormItemLongWrapper>
          {/* line */}
        </ModuleFormWrapper>
      </div>
    </form>
  );
};

export default index;
